import { render } from "./businessProcess.vue?vue&type=template&id=80fa838a&scoped=true&ts=true"
import script from "./businessProcess.vue?vue&type=script&lang=ts"
export * from "./businessProcess.vue?vue&type=script&lang=ts"

import "./businessProcess.vue?vue&type=style&index=0&id=80fa838a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80fa838a"]])

export default __exports__